import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import store from './store';
import { Provider } from 'react-redux';
import "bootstrap/dist/css/bootstrap.min.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdatePrompt from './Componenets/UpdatePrompt';

const root = ReactDOM.createRoot(document.getElementById('root'));

function renderApp(updateAvailable, registration) {
  root.render(
    <BrowserRouter>
      <React.StrictMode>
        <Provider store={store}>
          <App />
          {updateAvailable && (
            <UpdatePrompt onUpdate={() => {
              if (registration && registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                registration.waiting.addEventListener('statechange', (e) => {
                  if (e.target.state === 'activated') {
                    window.location.reload();
                  }
                });
              } else {
                window.location.reload();
              }
            }} />
          )}
        </Provider>
      </React.StrictMode>
    </BrowserRouter>
  );
}

renderApp(false, null);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    renderApp(true, registration);
  },
  onSuccess: () => {
    console.log('App is cached for offline use.');
  },
});

reportWebVitals();
